// 「典型应用」卡片：点击整卡打开通用弹窗，展示被截断的完整描述
import { initModal } from "../modal/main";
import { SOLUTION_MODAL_ID } from "./constants";

/** 把典型应用卡片接到详情弹窗上（弹窗结构由 SSR 输出） */
export function initSolutionCards() {
	const cards = document.querySelectorAll<HTMLElement>("[data-solution-card]");
	if (cards.length === 0) return;

	const modal = initModal(SOLUTION_MODAL_ID);
	if (!modal) return;

	for (const card of cards) {
		const contentEl = card.querySelector<HTMLElement>(".card-content");
		// 与视图同一判定规则（去标签后为空即视为无描述），避免打开只有标题的空白弹窗
		if (!contentEl?.innerHTML.replace(/<[^>]*>/g, "").trim()) continue;

		card.addEventListener("click", () => {
			// 卡片内的描述与弹窗共用同一份内容，仅由 CSS 截断，此处整体拷贝
			const url = card.dataset.solutionUrl?.trim();
			modal.open({
				title: card.dataset.solutionTitle || "",
				index: card.querySelector(".card-index")?.textContent || "",
				content: contentEl.innerHTML,
				link: url ? { href: url } : null,
				trigger: card.querySelector<HTMLElement>(".solution-card-hit"),
			});
		});
	}
}
